import { useTexts } from 'utils/useTexts';
import useEffectOnce from '@shared/hooks/useEffectOnce';
import { useAnalytics } from '@shared/hooks/useAnalytics';
import { SEGMENT_SCREEN_PARAMS } from '@shared/constants/segmentConstants';

const DisqualifiedLowCreditScore = () => {
  const { t } = useTexts();
  const { trackPage } = useAnalytics(SEGMENT_SCREEN_PARAMS.OFFER_OFF_RAMP,false);

  useEffectOnce(() =>
    trackPage(t('pageTitles.DeclineCredit') + '- Low credit Score', {
      off_ramp_variant: 'schedule_consult',
      trigger_reason: 'user_decline',
    })
  );

  return (
    <div className="iLendingCDX-disqualified-container">
      <h1 className="iLendingCDX-form-title iLendingCDX-mb-8">{t('disqualifiedLowCreditScore.title')}</h1>
      <p className="iLendingCDX-mb-4">{t('disqualifiedLowCreditScore.startText')}</p>
      <p className="iLendingCDX-mb-4">{t('disqualifiedLowCreditScore.midText')}</p>

      <p className="iLendingCDX-mb-4">{t('disqualifiedLowCreditScore.endText')}</p>
    </div>
  );
};

export default DisqualifiedLowCreditScore;
